import { Modal } from "antd";
import { useState } from "react";
import Loader from "../../loader/loader";
import BtnEditSvg from "../Button/btnEditSvg";
import EmployeeDesignation from "../EmployeeDesignation";
import DesignationAddSinglePopup from "./DesignationAddSinglePopup";
import EmployeeDepartment from "../EmployeeDepartment";
import DepartmentAddSinglePopup from "./DepartmentAddSinglePopup";

const DepartmentEditPopup = ({ data }) => {
  // console.log("datakijhgv", data);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button onClick={showModal} className="mt-4 mr-2">
        <BtnEditSvg size={25} />
      </button>
      <Modal
        title="Edit Department"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {!loading ? (
          <>
            <EmployeeDepartment
              list={data} // Pass data to EmployeeDesignation
              edit={true}
              setLoading={setLoading}
            />
            <DepartmentAddSinglePopup
              list={data} // Pass data instead of list
              setLoading={setLoading}
            />
          </>
        ) : (
          <Loader />
        )}
      </Modal>
    </>
  );
};

export default DepartmentEditPopup;